export const COUNTRIES = [
  { code: "IN", name: "India", dialCode: "+91" },
  { code: "US", name: "United States", dialCode: "+1" },
  { code: "GB", name: "United Kingdom", dialCode: "+44" },
  { code: "AE", name: "United Arab Emirates", dialCode: "+971" },
  { code: "SG", name: "Singapore", dialCode: "+65" },
  { code: "AU", name: "Australia", dialCode: "+61" },
  { code: "DE", name: "Germany", dialCode: "+49" },
  { code: "FR", name: "France", dialCode: "+33" },
  { code: "JP", name: "Japan", dialCode: "+81" },
  { code: "CA", name: "Canada", dialCode: "+1" },
];

export const STATES_BY_COUNTRY = {
  IN: [
    "Telangana",
    "Andhra Pradesh",
    "Maharashtra",
    "Karnataka",
    "Tamil Nadu",
    "Kerala",
    "Delhi",
    "Gujarat",
    "Rajasthan",
    "West Bengal",
    "Uttar Pradesh",
    "Punjab",
    "Haryana",
    "Madhya Pradesh",
    "Bihar",
  ],
  US: ["California", "Texas", "New York", "Florida", "Illinois", "Washington", "Georgia", "New Jersey"],
  GB: ["England", "Scotland", "Wales", "Northern Ireland"],
  AE: ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah"],
  SG: ["Central Region", "North Region", "East Region", "West Region"],
  AU: ["New South Wales", "Victoria", "Queensland", "Western Australia", "South Australia"],
  DE: ["Bavaria", "Berlin", "Hesse", "Hamburg", "Saxony"],
  FR: ["Île-de-France", "Auvergne-Rhône-Alpes", "Occitanie", "Brittany"],
  JP: ["Tokyo", "Osaka", "Hokkaido", "Kyoto", "Fukuoka"],
  CA: ["Ontario", "Quebec", "British Columbia", "Alberta"],
};

export const CITIES_BY_STATE = {
  Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam", "Nalgonda"],
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Tirupati", "Nellore"],
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane", "Aurangabad"],
  Karnataka: ["Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Trichy", "Salem"],
  Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur"],
  Delhi: ["New Delhi", "Central Delhi", "South Delhi", "North Delhi"],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot"],
  Rajasthan: ["Jaipur", "Udaipur", "Jodhpur", "Kota"],
  "West Bengal": ["Kolkata", "Howrah", "Siliguri", "Durgapur"],
  "Uttar Pradesh": ["Lucknow", "Noida", "Kanpur", "Varanasi", "Agra"],
  Punjab: ["Ludhiana", "Amritsar", "Chandigarh", "Jalandhar"],
  Haryana: ["Gurugram", "Faridabad", "Panipat", "Ambala"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Gwalior", "Jabalpur"],
  Bihar: ["Patna", "Gaya", "Muzaffarpur"],
  California: ["Los Angeles", "San Francisco", "San Diego", "San Jose", "Sacramento"],
  Texas: ["Houston", "Dallas", "Austin", "San Antonio"],
  "New York": ["New York City", "Buffalo", "Rochester", "Albany"],
  Florida: ["Miami", "Orlando", "Tampa", "Jacksonville"],
  Illinois: ["Chicago", "Springfield", "Naperville"],
  Washington: ["Seattle", "Spokane", "Tacoma"],
  Georgia: ["Atlanta", "Savannah", "Augusta"],
  "New Jersey": ["Newark", "Jersey City", "Trenton"],
  England: ["London", "Manchester", "Birmingham", "Leeds", "Liverpool"],
  Scotland: ["Edinburgh", "Glasgow", "Aberdeen"],
  Wales: ["Cardiff", "Swansea", "Newport"],
  "Northern Ireland": ["Belfast", "Derry"],
  Dubai: ["Dubai"],
  "Abu Dhabi": ["Abu Dhabi"],
  Sharjah: ["Sharjah"],
  "Central Region": ["Singapore Central"],
  "North Region": ["Woodlands"],
  "East Region": ["Tampines"],
  "West Region": ["Jurong"],
  "New South Wales": ["Sydney", "Newcastle", "Wollongong"],
  Victoria: ["Melbourne", "Geelong"],
  Queensland: ["Brisbane", "Gold Coast", "Cairns"],
  "Western Australia": ["Perth", "Fremantle"],
  "South Australia": ["Adelaide"],
  Bavaria: ["Munich", "Nuremberg"],
  Berlin: ["Berlin"],
  Hesse: ["Frankfurt", "Wiesbaden"],
  Hamburg: ["Hamburg"],
  Saxony: ["Dresden", "Leipzig"],
  "Île-de-France": ["Paris", "Versailles"],
  "Auvergne-Rhône-Alpes": ["Lyon", "Grenoble"],
  Occitanie: ["Toulouse", "Montpellier"],
  Brittany: ["Rennes", "Brest"],
  Tokyo: ["Tokyo"],
  Osaka: ["Osaka"],
  Hokkaido: ["Sapporo"],
  Kyoto: ["Kyoto"],
  Fukuoka: ["Fukuoka"],
  Ontario: ["Toronto", "Ottawa", "Mississauga"],
  Quebec: ["Montreal", "Quebec City"],
  "British Columbia": ["Vancouver", "Victoria BC"],
  Alberta: ["Calgary", "Edmonton"],
};
